import { render, staticRenderFns } from "./JxCountDetail.vue?vue&type=template&id=15ebd9be&scoped=true"
import script from "./JxCountDetail.vue?vue&type=script&lang=js"
export * from "./JxCountDetail.vue?vue&type=script&lang=js"
import style0 from "./JxCountDetail.vue?vue&type=style&index=0&id=15ebd9be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ebd9be",
  null
  
)

export default component.exports